export default __webpack_public_path__ + "static/media/copy.cf5f2e77.svg";